<template>
  <Home />
</template>
<script setup>
import Home from "@/views/Home/Home.vue";
</script>
